import { ItemCompleteProps } from "app/shared/components/modal/auto-complete/auto-complete";
import i18n from "app/shared/language/i18n";
import { RESPONSEDATA } from "app/shared/services/services-model.type";
import maturityArray from "app/shared/util/data-json/maturity-array.json";
import productArray from "app/shared/util/data-json/product-term-deposit-array.json";

export const LINK_TERM =
  "https://www.pvcombank.com.vn/static/product/2022/Dieukhoan/B%E1%BA%A3n%20%C4%91i%E1%BB%81u%20kho%E1%BA%A3n%20%C4%91i%E1%BB%81u%20ki%E1%BB%87n%20v%E1%BB%81%20ti%E1%BB%81n%20g%E1%BB%ADi%20ti%E1%BA%BFt%20ki%E1%BB%87m_final%20(1).pdf";

interface ItemBranch {
  ID: number;
  BRANCHCODE: string;
  BRANCHNAME: string;
  ADDRESS: string;
  POSTCODE: string;
  BRANCHTYPE: any;
  PROVINCECODE: string;
  PROVINCENAME: string;
  PROVINCENAME_VN: string;
  DISTRICTCODE: string;
  DISTRICTNAME: string;
  DISTRICTNAME_EN: string;
}

interface BranchDataJson {
  BRANCH: ItemBranch[];
}

let branchTermDeposit: BranchDataJson;

export const getIntRate = (value?: string) => {
  if (value?.length) {
    let rateArray = value.split(" ");
    if (rateArray.length) return rateArray[rateArray.length - 1];
  }
  return "0";
};

export const formatTextTerm = (id?: string, name?: string) => {
  let str = id + " " + name;
  let timer = "";
  if (id?.length && name?.length) {
    if (id === "1") {
      if (name === "W") timer = i18n.t("COMMON_MOT_TUAN");
      else if (name === "M") timer = i18n.t("COMMON_MOT_THANG");
      else if (name === "D") timer = i18n.t("COMMON_MOT_NGAY");
    } else {
      if (name === "W") timer = i18n.t("COMMON_NHIEU_TUAN");
      else if (name === "M") timer = i18n.t("COMMON_NHIEU_THANG");
      else if (name === "D") timer = i18n.t("COMMON_NHIEU_NGAY");
    }
  }
  str = String(Number(id)) + " " + timer;
  return str;
};

export const formatFdTerm = (str?: string) => {
  let msg: string = "";
  if (str?.length) {
    str = str.replace("-", "");
    msg = formatTextTerm(str.substr(0, str.length - 1), str.substr(str.length - 1));
  }
  return msg;
};

export function loadBranchTermDeposit() {
  return new Promise(async (resolve) => {
    if (!branchTermDeposit) branchTermDeposit = await import("../../../shared/util/data-json/branch-local-array.json");
    resolve(0);
  });
}

export const getTermDepositInfoData = (data?: RESPONSEDATA) => {
  const listProduct: ItemCompleteProps[] = [];
  const listBranch: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("28") && indexList["28"].LIST_CONTROL_VALUE?.length) {
    indexList["28"].LIST_CONTROL_VALUE.forEach((item) => {
      const productFilter = productArray.PRODUCT.filter((product) => {
        return product.CODE === item.ID;
      });
      let name = item.NAME || "";
      if (productFilter.length) {
        name = i18n.language === "en" ? productFilter[0].NAME.en : productFilter[0].NAME.vi;
      }
      listProduct.push({ value: item.ID || "", label: name || "", other: item.Other || "" });
    });
  }
  if (indexList && indexList.hasOwnProperty("34") && indexList["34"].LIST_CONTROL_VALUE?.length) {
    indexList["34"].LIST_CONTROL_VALUE.forEach((item) => {
      const branchFilter = branchTermDeposit.BRANCH.filter((branch) => {
        return item?.ID?.length && item.ID.indexOf(String(branch.BRANCHCODE)) >= 0;
      });
      let name = item.NAME || "";
      if (branchFilter.length) {
        name = branchFilter[0].BRANCHNAME;
      }
      listBranch.push({ value: item.ID || "", label: name, other: item.Other || "" });
    });
  }

  return { listProduct, listBranch };
};

export const getTermDepositListMaturity = (data?: RESPONSEDATA) => {
  const list: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("27") && indexList["27"].LIST_CONTROL_VALUE?.length) {
    indexList["27"].LIST_CONTROL_VALUE.forEach((item) => {
      const maturityFilter = maturityArray.MATURITY.filter((mat) => {
        return mat.CODE === item.ID;
      });
      let name = item.NAME || "";
      if (maturityFilter.length) {
        name = i18n.language === "en" ? maturityFilter[0].NAME.en : maturityFilter[0].NAME.vi;
      }
      list.push({ value: item.ID || "", label: name, other: item.Other || "" });
    });
  }
  return list;
};

export const getTermDepositListTerm = (data?: RESPONSEDATA) => {
  const list: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("29") && indexList["29"].LIST_CONTROL_VALUE?.length) {
    indexList["29"].LIST_CONTROL_VALUE.forEach((item) => {
      const termName = formatTextTerm(item.ID, item.NAME);

      list.push({ value: item.ID || "", label: termName || "", other: item.Other || "", name: item.NAME });
    });
  }
  return list;
};

export const getTermDepositProductName = (value?: string) => {
  if (value?.length) {
    const productFilter = productArray.PRODUCT.filter((product) => {
      return product.CODE === value;
    });
    if (productFilter.length) return i18n.language === "en" ? productFilter[0].NAME.en : productFilter[0].NAME.vi;
    return value;
  }
  return "";
};

export const getTermDepositMaturityName = (value?: string) => {
  if (value?.length) {
    const maturityFilter = maturityArray.MATURITY.filter((mat) => {
      return mat.CODE === value;
    });
    if (maturityFilter.length) return i18n.language === "en" ? maturityFilter[0].NAME.en : maturityFilter[0].NAME.vi;
    return value;
  }
  return "";
};

export const getTermDepositBranchName = (value?: string) => {
  if (value?.length) {
    const branchFilter = branchTermDeposit.BRANCH.filter((branch) => {
      return value?.length && value.indexOf(String(branch.BRANCHCODE)) >= 0;
    });
    if (branchFilter.length) {
      const name = branchFilter[0].BRANCHNAME;
      return name;
    }
  }
  return value;
};
